import { type StateCreator } from 'zustand';

/**
 * Slice controlling whether the middle "board view" (the board's asset grid that sits
 * between the sidebar and the canvas) is collapsed. When collapsed, the board view
 * shrinks to zero width and the canvas right panel expands to fill the freed space.
 * Only meaningful while the canvas right panel is open.
 */
export type BoardViewCollapseSlice = {
  boardViewCollapsed: boolean;
  setBoardViewCollapsed: (boardViewCollapsed: boolean) => void;
  toggleBoardView: () => void;
};

export type CreateBoardViewCollapseSlice = () => StateCreator<BoardViewCollapseSlice, [], [], BoardViewCollapseSlice>;

export const createBoardViewCollapseSlice: CreateBoardViewCollapseSlice = () => (set) => ({
  boardViewCollapsed: false,
  setBoardViewCollapsed: (boardViewCollapsed: boolean) => set({ boardViewCollapsed }),
  toggleBoardView: () => set((state) => ({ boardViewCollapsed: !state.boardViewCollapsed })),
});
